import React from "react";
import { Link } from "react-router-dom";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import Reveal from "@/components/marketing/Reveal";
import { getWallets } from "@/data/site";
import { useI18n } from "@/context/I18nContext";

export default function WalletsIndex() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Wallet supportati", "Supported wallets", "Unterstützte Wallets"), L("Categorie di wallet software e hardware analizzate da Recovers Crypto.", "Software and hardware wallet categories analyzed by Recovers Crypto.", "Von Recovers Crypto analysierte Software- und Hardware-Wallet-Kategorien."));
  const wallets = getWallets(lang);
  return (
    <div>
      <PageHero eyebrow={L("Wallet supportati", "Supported wallets", "Unterstützte Wallets")} title={L("Wallet che possiamo analizzare", "Wallets we can analyze", "Wallets, die wir analysieren können")}
        subtitle={L("La fattibilità del recupero dipende dal tipo di wallet e dal materiale ancora a tua disposizione.", "Recovery feasibility depends on the wallet type and the material you still have.", "Die Machbarkeit der Wiederherstellung hängt vom Wallet-Typ und den Ihnen noch verfügbaren Unterlagen ab.")} />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {wallets.map((w, i) => (
            <Reveal key={w.slug} delay={i * 0.03}>
              <Link to={`/wallet/${w.slug}`} data-testid={`wallet-index-${w.slug}`} className="block rounded-xl border border-white/10 bg-navy-paper p-6 hover:border-cyanx/30 hover:bg-white/5 transition-all">
                <div className="font-heading text-lg text-white font-medium">{w.name}</div>
                <div className="text-xs text-slate-500 mt-1">{w.type}</div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
